import './UndoManualCompletion.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Packages from '../../api/controllers/Packages/Packages';
import Error from '../Error/Error';

// General UndoManualCompletion Component
const UndoManualCompletion = ({ pkg, setModalOpen, refetchPackages }) => {
  const [error, setError] = useState();

  const undoManuallyCompletePackage = () => {
    Packages.manuallyUncomplete(pkg.package.id)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="undo_manual_completion_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      <div className="message">Are you sure you want to reinstate {pkg.packageName}?</div>
      <div className="undo_manual_completion_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={undoManuallyCompletePackage}>
          OK
        </button>
      </div>
    </div>
  );
};

UndoManualCompletion.propTypes = {
  pkg: PropTypes.object,
  setModalOpen: PropTypes.func,
  refetchPackages: PropTypes.func,
};

export default UndoManualCompletion;
